"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoadingTable = void 0;
const react_1 = __importDefault(require("react"));
const __1 = require("..");
const LoadingTable = (props) => {
    const { isLoading, isDirty, children } = props;
    const loadingOverlayProps = {
        isLoading: isLoading || isDirty,
        hideLoader: !isLoading,
        loadingMessage: isLoading ? undefined : '',
        modificators: 'top',
    };
    return (react_1.default.createElement(__1.LoadingOverlay, { ...loadingOverlayProps }, children));
};
exports.LoadingTable = LoadingTable;
//# sourceMappingURL=index.js.map